import ILoteRequest from '../entities/LoteRequest'
import ILoteResponse from '../entities/LoteResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IFindAll {
  execute(params: ILoteRequest): Promise<ILoteResponse>
}

export default class IFindAllImpl implements IFindAll {
  constructor(private readonly loteRepository: ILoteRepository) {}

  public async execute(params: ILoteRequest): Promise<ILoteResponse> {
    const response = await this.loteRepository.findAll(params)

    return response
  }
}
